import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { withRouter, Link } from "react-router-dom";
import filterFactory, {
  textFilter,
  selectFilter,
} from "react-bootstrap-table2-filter";
import { Tooltip } from "@material-ui/core";
import { Alert } from "reactstrap";
import Select from "react-select";
import {
  addNewPayment,
  getParticipantSchemelist, // this same call also returns csr_staff into the AddPayment reducer
} from "store/Payment/actions";

import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Label,
  Button,
  Input,
} from "reactstrap";
import {
  getApprovedLabs,
  updateMembershipStatus,
} from "store/registration-admin/actions";
import { getcyclelist } from "store/cycle/actions";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import * as Yup from "yup";
import Breadcrumbs from "components/Common/Breadcrumb";
import {
  getpartpayment,
  addremainingpayment,
} from "store/registration-admin/actions";
import "assets/scss/table.scss";

class PartialPayment2 extends Component {
  constructor(props) {
    super(props);
    this.node = React.createRef();
    const selectedParticipant =
      (this.props.location &&
        this.props.location.state &&
        this.props.location.state.selectedParticipant) ||
      {};
    console.log("tt", selectedParticipant);
    this.state = {
      selectedParticipant,
      AllLabs: [],
      selectedScheme: null,
      paymentType: "partial", // default page
      id: "",
      btnText: "Copy",
      organization_name: "",
      tooltipContent: ["Worst", "Bad", "Average", "Good", "Excellent"],
      filteredLabs: [],
      CycleList: [],
      selectedParticipantType: "All Participant",
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "",
      successMessage: "",
      localPartPaymentData: null, // <-- add this
    };
  }

  componentDidMount() {
    console.log("Fetching data...", this.state.selectedParticipant);
    const authUser = localStorage.getItem("authUser");
    const user_id = authUser ? JSON.parse(authUser).user_id : null;

    if (!user_id) {
      console.error("User ID is missing. Cannot proceed with API calls.");
      return;
    }

    console.log("Retrieved user_id:", user_id);

    this.setState({ user_id }, () => {
      const { organization_name } = this.props.match.params || {};
      console.log("organization_name from props:", organization_name);

      if (organization_name) {
        this.setState({ organization_name }, () => {
          console.log("Organization name set:", this.state.organization_name);
          this.fetchData(this.state.user_id);
        });
      } else {
        console.error("Organization name is missing in URL parameters.");
      }
    });
  }

  fetchData(user_id) {
    const participantId = this.state.selectedParticipant?.id;

    console.log("Participant ID sent to API:", participantId);

    if (!participantId) {
      console.error("❌ ERROR: selectedParticipant.id is missing!");
      return;
    }

    this.props.onGetpartpayment(participantId);
    this.props.ongetcyclelist(user_id);
    this.props.onGetParticipantPayment(user_id); // populates PaymentSchemeList + csr_staff (CSRList)
  }

  componentDidUpdate(prevProps, prevState) {
    // Update filteredLabs if it changes
    if (prevState.filteredLabs !== this.state.filteredLabs) {
      console.log("FilteredLabs updated:", this.state.filteredLabs);
    }

    // Update CycleList in state if props change
    if (prevProps.CycleList !== this.props.CycleList) {
      console.log("Updating CycleList in state:", this.props.CycleList);
      this.setState({ CycleList: this.props.CycleList });
    }

    // Update AllLabs in state if props change
    if (prevProps.AllLabs !== this.props.AllLabs) {
      console.log("Updated AllLabs:", this.props.AllLabs);
      this.setState({ AllLabs: this.props.AllLabs }, () => {
        console.log("State AllLabs updated:", this.state.AllLabs);
        this.applyFilters();
      });
    }

    // Update filteredCycleList when AllLabs or CycleList change
    if (
      prevProps.AllLabs !== this.props.AllLabs ||
      prevProps.CycleList !== this.props.CycleList
    ) {
      console.log("Filtering CycleList for participants");

      const participantSchemes = new Set(
        this.props.AllLabs.flatMap(
          lab => lab.schemes?.map(scheme => scheme.scheme_name) || []
        )
      );

      this.setState({
        CycleList: this.props.CycleList,
        filteredCycleList: Array.from(participantSchemes),
      });
    }

    // Update localPartPaymentData when API response arrives
    if (prevProps.partPaymentData !== this.props.partPaymentData) {
      console.log("API partPaymentData received:", this.props.partPaymentData);
      this.setState({ localPartPaymentData: this.props.partPaymentData });
    }

    // Log CSRList updates
    if (prevProps.CSRList !== this.props.CSRList) {
      console.log("CSRList prop updated:", this.props.CSRList);
      console.log("CSRList length:", this.props.CSRList?.length);
    }
  }

  onPaginationPageChange = page => {
    if (
      this.node &&
      this.node.current &&
      this.node.current.props &&
      this.node.current.props.pagination &&
      this.node.current.props.pagination.options
    ) {
      this.node.current.props.pagination.options.onPageChange(page);
    }
  };

  refreshPage = () => {
    this.fetchData(this.state.user_id);
    this.applyFilters();
  };

  render() {
    console.log("Rendering table with data:", this.state.filteredLabs);
    const { SearchBar } = Search;

    const { AllLabs, partPaymentData } = this.props;
    const { filteredLabs, selectedParticipantType, selectedScheme } =
      this.state;

    const csrOptions = (this.props.CSRList || []).map(username => ({
      value: username,
      label: username,
    }));
    console.log("render() - csrOptions built:", csrOptions);

    const pageOptions = {
      sizePerPage: 50,
      totalSize: AllLabs.length,
      custom: true,
    };

    const { approvedLabs, CycleList } = this.state;

    // Backend returns scheme as a comma-separated string, e.g. "29-26,37-30"
    // (see GetPartPaymentAPIView -> "scheme": payment.scheme). Normalize it
    // into a clean array of "scheme_id-cycle_id" strings so both the Select
    // and Formik's `values.scheme` work with real arrays, not a raw string.
    const attachedSchemeIds =
      typeof partPaymentData?.scheme === "string"
        ? partPaymentData.scheme
            .split(",")
            .map(s => s.trim())
            .filter(Boolean)
        : Array.isArray(partPaymentData?.scheme)
        ? partPaymentData.scheme
        : [];

    const schemeOptions = CycleList.filter(scheme => {
      const comboId = `${scheme.scheme_id}-${scheme.id}`;
      const isActive =
        scheme.status && scheme.status.toLowerCase() === "active";
      const isAlreadyAttached = attachedSchemeIds.includes(comboId);
      return isActive || isAlreadyAttached;
    }).map(scheme => {
      const isActive =
        scheme.status && scheme.status.toLowerCase() === "active";
      return {
        value: `${scheme.scheme_id}-${scheme.id}`,
        label: `(Scheme Name: ${scheme.scheme_name}) - (Cycle Number: ${
          scheme.cycle_no
        })${isActive ? "" : " [Inactive]"}`,
        scheme_id: scheme.scheme_id,
        cycle_id: scheme.id,
      };
    });

    console.log("Mapped scheme option:", schemeOptions);

    const defaultSorted = [{ dataField: "id", order: "desc" }];

    const customStyles = {
      control: provided => ({
        ...provided,
        minHeight: "38px",
      }),
    };

    return (
      <React.Fragment>
        <div
          className="page-content"
          style={{ width: "80%", margin: "100px auto" }}
        >
          <MetaTags>
            <title>Remaining Payment for Participant | Lab Management</title>
          </MetaTags>
          <Container fluid>
            <h2 className="page-title">
              {this.state.selectedParticipant?.name || "Unknown"} - Remaining
              Payment
            </h2>
            <div className="mt-3 mb-3">
              <Label>Payment Type</Label>
              <Input
                type="select"
                value={this.state.paymentType}
                onChange={e => {
                  const type = e.target.value;
                  const participant = this.state.selectedParticipant;

                  this.setState({ paymentType: type });

                  if (type === "new") {
                    // Redirect to New Payment page
                    this.props.history.push({
                      pathname: `/${this.state.organization_name}/payment/${participant.id}`,
                      state: { selectedParticipant: participant },
                    });
                  }
                }}
              >
                {/* <option value="">Select Payment Type</option> */}
                <option value="new">New Payment</option>
                <option value="partial">Partial Payment</option>
              </Input>
            </div>

            <Row>
              <Col lg={12}>
                <Card>
                  <CardBody>
                    <Formik
                      enableReinitialize
                      initialValues={{
                        photoFile: null,
                        photoUrl: partPaymentData?.photo || "",
                        participant: this.state.selectedParticipant?.id || "",
                        paydate: partPaymentData?.paydate || "",
                        payment_status: partPaymentData?.payment_status || "",
                        payment_settlement:
                          partPaymentData?.payment_settlement || "",
                        priceBeforeDiscount:
                          partPaymentData?.priceBeforeDiscount || "",
                        paymentmethod: partPaymentData?.paymentmethod || "",
                        discountAmount: partPaymentData?.discountAmount || "",
                        taxDeduction: partPaymentData?.taxDeduction || "",
                        // was: partPaymentData?.scheme || []  (that left it as a
                        // raw comma-separated string instead of an array)
                        scheme: attachedSchemeIds,
                        part_payment_amount:
                          partPaymentData?.part_payment_amount || "",
                        remaining_amount:
                          partPaymentData?.remaining_amount || "",
                        purchase_order_copy: "",
                        price: partPaymentData?.price || "",
                        discount: partPaymentData?.discount || "-",
                        receivedby: partPaymentData?.receivedby || "",
                        csrcomments: partPaymentData?.csrcomments || "",
                        added_by: this.state.user_id || "",
                      }}
                      validationSchema={Yup.object().shape({
                        participant: Yup.string().required(
                          "Participant is required"
                        ),
                        payment_status: Yup.string().required(
                          "Payment status is required"
                        ),
                        paydate: Yup.string().required("Date is required"),
                        paymentmethod: Yup.string().required(
                          "Payment Method is required"
                        ),
                        receivedby: Yup.string().required(
                          "Received By is required"
                        ),
                        photoFile: Yup.mixed()
                          .required("Deposit Slip is required")
                          .test(
                            "fileSize",
                            "File too large",
                            value =>
                              !value || (value && value.size <= 2 * 1024 * 1024)
                          )
                          .test(
                            "fileType",
                            "Unsupported file format",
                            value =>
                              !value ||
                              [
                                "image/jpeg",
                                "image/png",
                                "image/jpg",
                                "application/pdf",
                              ].includes(value.type)
                          ),
                        discountAmount: Yup.number().nullable(),
                        taxDeduction: Yup.number().nullable(),
                        price: Yup.number()
                          .required("Price is required")
                          .min(0, "Price cannot be negative"),
                        remaining_amount: Yup.number().nullable(),
                        part_payment_amount: Yup.number().nullable(),
                      })}
                      onSubmit={async (
                        values,
                        { setSubmitting, resetForm }
                      ) => {
                        try {
                          const userId = this.state.user_id;
                          const total = parseFloat(
                            values.priceBeforeDiscount || 0
                          );
                          const discount = parseFloat(
                            values.discountAmount || 0
                          );
                          const tax = parseFloat(values.taxDeduction || 0);

                          let partAmount = parseFloat(
                            values.part_payment_amount || 0
                          );
                          let remainingAmount = parseFloat(
                            values.remaining_amount || 0
                          );

                          if (values.payment_settlement === "Part") {
                            if (
                              values.part_payment_amount &&
                              !values.remaining_amount
                            ) {
                              remainingAmount =
                                total - discount - tax - partAmount;
                            } else if (
                              !values.part_payment_amount &&
                              values.remaining_amount
                            ) {
                              partAmount =
                                total - discount - tax - remainingAmount;
                            } else {
                              partAmount = partAmount || 0;
                              remainingAmount = remainingAmount || 0;
                            }
                          } else if (values.payment_settlement === "Full") {
                            partAmount = total - discount - tax;
                            remainingAmount = 0;
                          }

                          const payload = {
                            ...values,
                            // Backend expects scheme as a comma-separated
                            // string (matches what GetPartPaymentAPIView
                            // returns) — join the array back before sending.
                            scheme: Array.isArray(values.scheme)
                              ? values.scheme.join(",")
                              : values.scheme,
                            price: parseFloat(values.price).toFixed(2),
                            part_payment_amount: partAmount.toFixed(2),
                            remaining_amount: remainingAmount.toFixed(2),
                            added_by: userId,
                            photo: values.photoFile || values.photoUrl,
                            csrcomments: values.csrcomments,
                          };

                          await this.props.onAddremainingpayment(payload);

                          this.setState(
                            {
                              successMessage:
                                "Participant's payment updated successfully",
                            },
                            () => {
                              setTimeout(
                                () => this.setState({ successMessage: "" }),
                                3000
                              );
                            }
                          );

                          resetForm();
                        } catch (error) {
                          console.error("Error adding payment:", error);
                          this.setState({
                            successMessage:
                              "Failed to save payment. Please try again.",
                          });
                        }

                        setSubmitting(false);
                        setTimeout(
                          () => this.props.ongetcyclelist(this.state.user_id),
                          1000
                        );
                      }}
                    >
                      {({
                        values,
                        errors,
                        touched,
                        setFieldValue,
                        submitForm,
                        initialValues,
                      }) => (
                        <Form>
                          {this.state.successMessage && (
                            <Alert color="success" className="mb-4">
                              {this.state.successMessage}
                            </Alert>
                          )}

                          <Row>
                            <Col>
                              <Label>Scheme</Label>
                              <Select
                                name="scheme"
                                isMulti
                                isDisabled
                                options={schemeOptions}
                                value={schemeOptions.filter(option =>
                                  values.scheme.includes(option.value)
                                )}
                                onChange={selectedOptions => {
                                  const selectedValues = selectedOptions
                                    ? selectedOptions.map(o => o.value)
                                    : [];
                                  setFieldValue("scheme", selectedValues);

                                  const totalPrice = selectedValues.reduce(
                                    (sum, combinedId) => {
                                      const [, cycleId] = combinedId
                                        .split("-")
                                        .map(Number);
                                      const scheme = this.props.CycleList.find(
                                        s => s.id === cycleId
                                      );
                                      return (
                                        sum +
                                        (scheme
                                          ? parseFloat(scheme.price || 0)
                                          : 0)
                                      );
                                    },
                                    0
                                  );

                                  setFieldValue(
                                    "priceBeforeDiscount",
                                    totalPrice.toFixed(2)
                                  );
                                  setFieldValue("price", totalPrice.toFixed(2));
                                }}
                              />
                              <ErrorMessage
                                name="scheme"
                                component="div"
                                className="invalid-feedback"
                              />
                            </Col>
                          </Row>
                          <Row className="mt-3">
                            <Col>
                              <Label>
                                Payable after Discount & Tax Deduction
                              </Label>
                              <Field name="price">
                                {({ field }) => (
                                  <input
                                    {...field}
                                    type="text"
                                    className="form-control"
                                    value={new Intl.NumberFormat("en-PK", {
                                      style: "currency",
                                      currency: "PKR",
                                    }).format(values.price || 0)}
                                    readOnly
                                    style={{ backgroundColor: "#e9ecef" }}
                                  />
                                )}
                              </Field>
                            </Col>
                          </Row>
                          <Row className="mt-3">
                            <Col>
                              <Label>Remaining Amount</Label>
                              <input
                                type="text" // <-- CHANGE to "text" to show commas
                                className="form-control"
                                readOnly
                                style={{ backgroundColor: "#e9ecef" }}
                                value={
                                  initialValues.remaining_amount
                                    ? Number(
                                        initialValues.remaining_amount
                                      ).toLocaleString()
                                    : ""
                                }
                              />
                            </Col>
                          </Row>
                          <Row className="mt-3">
                            <Col>
                              <Label>New Paid Amount</Label>
                              <Field name="remaining_amount">
                                {({ field }) => (
                                  <input
                                    type="number"
                                    className={`form-control ${
                                      errors.remaining_amount &&
                                      touched.remaining_amount
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    value={
                                      field.value ===
                                      initialValues.remaining_amount
                                        ? ""
                                        : field.value
                                    }
                                    onChange={e =>
                                      setFieldValue(
                                        "remaining_amount",
                                        e.target.value
                                      )
                                    }
                                  />
                                )}
                              </Field>

                              <ErrorMessage
                                name="remaining_amount"
                                component="div"
                                className="invalid-feedback"
                              />
                            </Col>
                          </Row>

                          <Row className="mt-3">
                            <Col>
                              <Label>Pay Date</Label>
                              <Field
                                name="paydate"
                                type="date"
                                className="form-control"
                              />
                              <ErrorMessage
                                name="paydate"
                                component="div"
                                className="invalid-feedback"
                              />
                            </Col>
                          </Row>

                          <Row className="mt-3">
                            <Col>
                              <Label>Pay Copy</Label>
                              {!values.photoFile && values.photoUrl && (
                                <div className="mb-2">
                                  <a
                                    href={`https://externalqcapi.com/${values.photoUrl}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    View uploaded slip
                                  </a>
                                </div>
                              )}
                              <Input
                                id="formFile"
                                name="photoFile"
                                type="file"
                                accept=".jpg,.jpeg,.png,.pdf"
                                onChange={event =>
                                  setFieldValue(
                                    "photoFile",
                                    event.currentTarget.files[0]
                                  )
                                }
                                className={`form-control ${
                                  errors.photoFile && touched.photoFile
                                    ? "is-invalid"
                                    : ""
                                }`}
                              />
                              <small style={{ color: "#007bff" }}>
                                Only JPEG, PNG, or PDF files up to 2MB are
                                allowed.
                              </small>
                              <ErrorMessage
                                name="photoFile"
                                component="div"
                                className="invalid-feedback"
                              />
                            </Col>
                          </Row>

                          <Row className="mt-3">
                            <Col>
                              <Label>Payment Method</Label>
                              <Select
                                name="paymentmethod"
                                options={[
                                  { value: "Online", label: "Online" },
                                  { value: "Cheque", label: "Cheque" },
                                  { value: "Cash", label: "Cash" },
                                ]}
                                value={
                                  values.paymentmethod
                                    ? {
                                        value: values.paymentmethod,
                                        label: values.paymentmethod,
                                      }
                                    : null
                                }
                                onChange={option =>
                                  setFieldValue(
                                    "paymentmethod",
                                    option?.value || ""
                                  )
                                }
                                className={
                                  errors.paymentmethod && touched.paymentmethod
                                    ? "is-invalid"
                                    : ""
                                }
                              />
                              <ErrorMessage
                                name="paymentmethod"
                                component="div"
                                className="invalid-feedback"
                              />
                            </Col>
                          </Row>

                          <Row className="mt-3">
                            <Col>
                              <Label>Received By</Label>
                              <Select
                                name="receivedby"
                                options={csrOptions}
                                placeholder="Select CSR"
                                value={
                                  values.receivedby
                                    ? {
                                        value: values.receivedby,
                                        label: values.receivedby,
                                      }
                                    : null
                                }
                                onChange={option =>
                                  setFieldValue(
                                    "receivedby",
                                    option?.value || ""
                                  )
                                }
                                className={
                                  errors.receivedby && touched.receivedby
                                    ? "is-invalid"
                                    : ""
                                }
                              />
                              <ErrorMessage
                                name="receivedby"
                                component="div"
                                className="invalid-feedback"
                              />
                            </Col>
                          </Row>

                          <Row className="mt-3">
                            <Col>
                              <Label>Comments</Label>
                              <Field name="csrcomments">
                                {({ field }) => (
                                  <textarea
                                    {...field}
                                    rows={3}
                                    className={
                                      "form-control" +
                                      (errors.csrcomments && touched.csrcomments
                                        ? " is-invalid"
                                        : "")
                                    }
                                    placeholder="Enter any additional csrcomments"
                                  />
                                )}
                              </Field>
                              <ErrorMessage
                                name="csrcomments"
                                component="div"
                                className="invalid-feedback"
                              />
                            </Col>
                          </Row>

                          <div className="d-flex justify-content-end mt-4">
                            <Button color="primary" type="submit">
                              Save
                            </Button>
                            <Button
                              color="secondary"
                              onClick={() => this.props.history.goBack()}
                              className="ms-2"
                            >
                              Cancel
                            </Button>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

PartialPayment2.propTypes = {
  match: PropTypes.object,
  selectedParticipant: PropTypes.object,
  AllLabs: PropTypes.array,
  className: PropTypes.any,
  history: PropTypes.any,
  onAddremainingpayment: PropTypes.func,
  participantId: PropTypes.func,
  ongetcyclelist: PropTypes.func,
  onGetpartpayment: PropTypes.func,
  onGetParticipantPayment: PropTypes.func,
  CSRList: PropTypes.array,
  PaymentSchemeList: PropTypes.array,
  location: PropTypes.shape({
    search: PropTypes.string,
    state: PropTypes.shape({
      selectedParticipant: PropTypes.object,
    }),
  }),
  CycleList: PropTypes.array,
  participant: PropTypes.any,

  // ✅ Add this block for partPaymentData
  partPaymentData: PropTypes.shape({
    photo: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    paydate: PropTypes.string,
    priceBeforeDiscount: PropTypes.string,
    payment_status: PropTypes.string,
    payment_settlement: PropTypes.string,
    paymentmethod: PropTypes.string,
    discountAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    taxDeduction: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    // Backend returns this as a comma-separated string (e.g. "29-26,37-30"),
    // normalized to an array in render() via `attachedSchemeIds`.
    scheme: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    part_payment_amount: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    remaining_amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    discount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    receivedby: PropTypes.string,
    csrcomments: PropTypes.string,
  }),
};

const mapStateToProps = ({
  Account,
  registrationAdmin,
  CycleList,
  PaymentScheme,
  AddPayment,
}) => {
  return {
    userID: Account?.userID || null,
    AllLabs: registrationAdmin?.AllLabs || [],
    approvedLabs: registrationAdmin?.approvedLabs || [],
    CycleList: CycleList?.CycleList || [],
    partPaymentData: registrationAdmin?.partpayment || null, // <--- ADD THIS
    CSRList: AddPayment?.csr_staff || [],
    PaymentSchemeList: AddPayment?.PaymentSchemeList || [],
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onGetpartpayment: id => dispatch(getpartpayment(id)),
  ongetcyclelist: id => dispatch(getcyclelist(id)),
  onAddremainingpayment: payment => dispatch(addremainingpayment(payment)),
  onGetParticipantPayment: id => dispatch(getParticipantSchemelist(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PartialPayment2));